import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangePickerComponent } from './components/range-picker/range-picker.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RangePickerPopupComponent } from './components/range-picker-popup/range-picker-popup.component';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedUiInputsModule } from '@shared/ui/inputs';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { DateTimePickerComponent } from './components/datetime-picker/datetimepicker.component';
import { DatetimePickerGroupComponent } from './components/datetime-picker-group/datetime-picker-group.component';
import { RangePickerPopupGroupComponent } from './components/range-picker-popup-group/range-picker-popup-group.component';
import { TimeRangePickerComponent } from './components/timerange-picker/timerange-picker.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DatePickerGroupComponent } from './components/date-picker-group/date-picker-group.component';
import { SharedUtilsPipesModule } from '@shared/utils/pipes';
import { DatePickerModule } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    NgbDatepickerModule,
    SharedUiIconsModule,
    SharedUiInputsModule,
    SharedUiButtonsModule,
    NgbModule,
    NgxMaterialTimepickerModule,
    SharedUtilsPipesModule,
    DatePickerModule,
  ],
  declarations: [
    RangePickerComponent,
    RangePickerPopupComponent,
    DateTimePickerComponent,
    DatetimePickerGroupComponent,
    RangePickerPopupGroupComponent,
    TimeRangePickerComponent,
    DatePickerComponent,
    DatePickerGroupComponent,
  ],
  exports: [
    RangePickerComponent,
    RangePickerPopupComponent,
    RangePickerPopupGroupComponent,
    DateTimePickerComponent,
    DatetimePickerGroupComponent,
    TimeRangePickerComponent,
    DatePickerComponent,
    DatePickerGroupComponent,
  ],
})
export class SharedUiDatetimeModule {}
